var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLatest = function SvgLatest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 17.5h-15V9.584l7.5 1.89 7.5-1.89zM10 2.084a5 5 0 0 1 4.605 6.95L10 10.417 5.395 9.035A5 5 0 0 1 10 2.084m-1.768 5L10 8.85l1.768-1.768L10 5.317z"
  })));
};
export default SvgLatest;